var exports = {
  "h": "xa15a2ab7--a88b0a--address",
};

module.exports = exports;
